import _classPrivateFieldSet from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
var _sessionId = /*#__PURE__*/new WeakMap();
export class MemorySessionIdStorage {
  constructor() {
    _classPrivateFieldInitSpec(this, _sessionId, {
      writable: true,
      value: void 0
    });
  }
  getSessionId() {
    return _classPrivateFieldGet(this, _sessionId);
  }
  setSessionId(sessionId) {
    _classPrivateFieldSet(this, _sessionId, sessionId);
  }
  clearSessionId() {
    _classPrivateFieldSet(this, _sessionId, undefined);
  }
}